module.exports = __webpack_public_path__ + "img/em-01.a2190f74.jpeg";